import React, { useEffect, useRef, PropsWithChildren, CSSProperties, forwardRef } from 'react';
import SimpleBarLibrary from './simplebar';
import './styles/simplebar.css';
import { ThemeStyle } from '../../utils/const';
import classNames from 'classnames';

type SimpleBarProps = PropsWithChildren<{
	theme?: ThemeStyle;
	hideScroll?: 'vertical' | 'horizontal';
	style?: CSSProperties;
	className?: string;
	classNameInner?: string;
}>;

export const SimpleBar = forwardRef<HTMLDivElement, SimpleBarProps>(
	({ children, theme = ThemeStyle.Dark, hideScroll, className, style, classNameInner }, ref) => {
		const rootRef = useRef<HTMLDivElement>();
		const mergedRef = ref && 'current' in ref ? ref : rootRef;

		const componentClasses = classNames(
			`simplebar-react simplebar-react__${theme}`,
			{
				[`simplebar-react__hide-${hideScroll}`]: hideScroll,
			},
			className,
		);

		useEffect(() => {
			if (!mergedRef.current) return;

			new SimpleBarLibrary(mergedRef.current, { autoHide: true });
		}, [mergedRef]);

		return (
			<div
				ref={ref}
				className={componentClasses}
				data-simplebar-react='true'
				style={style}
			>
				<div className={classNameInner}>{children}</div>
			</div>
		);
	},
);
